import React, { useState } from 'react';
import { Button } from '../../../components/ui/Button';
import SafeIcon from '../../../common/SafeIcon';
import Toast from '../../../components/ui/Toast';
import { useToast } from '../../../hooks/useToast';

const DAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

export default function BarberAvailability() {
  const [schedule, setSchedule] = useState(
    DAYS.reduce((acc, day) => ({ ...acc, [day]: { enabled: true, start: '09:00', end: '18:00' } }), {})
  );
  
  const { toast, showToast, hideToast } = useToast();

  const toggleDay = (day) => {
    setSchedule(prev => ({ ...prev, [day]: { ...prev[day], enabled: !prev[day].enabled } }));
  };

  const updateTime = (day, field, value) => {
    setSchedule(prev => ({ ...prev, [day]: { ...prev[day], [field]: value } }));
  };

  return (
    <div className="animate-in fade-in duration-500 max-w-4xl relative">
      {toast && <Toast message={toast.message} type={toast.type} onClose={hideToast} />}

      <div className="flex justify-between items-center mb-8">
        <div>
          <h1 className="text-3xl font-bold text-brand-black">Availability</h1>
          <p className="text-gray-500 mt-1">Set your working hours for home-service bookings.</p>
        </div>
        <Button onClick={() => showToast('Schedule updated successfully!', 'success')}>Save Changes</Button>
      </div>

      <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
        <div className="divide-y divide-gray-100">
          {DAYS.map((day) => (
            <div key={day} className="p-6 flex flex-col sm:flex-row sm:items-center justify-between gap-4">
              <div className="flex items-center gap-4 min-w-[150px]">
                <div 
                  onClick={() => toggleDay(day)}
                  className={`w-12 h-6 rounded-full relative cursor-pointer transition-colors ${schedule[day].enabled ? 'bg-brand-gold' : 'bg-gray-200'}`}
                >
                  <div className={`absolute top-1 w-4 h-4 bg-white rounded-full transition-all ${schedule[day].enabled ? 'left-7' : 'left-1'}`} />
                </div>
                <span className={`font-bold ${schedule[day].enabled ? 'text-brand-black' : 'text-gray-400'}`}>{day}</span>
              </div>

              {schedule[day].enabled ? (
                <div className="flex items-center gap-3">
                  <input 
                    type="time" 
                    value={schedule[day].start}
                    onChange={(e) => updateTime(day, 'start', e.target.value)}
                    className="p-2 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-brand-gold/20 outline-none"
                  />
                  <span className="text-gray-400 text-sm">to</span>
                  <input 
                    type="time" 
                    value={schedule[day].end}
                    onChange={(e) => updateTime(day, 'end', e.target.value)}
                    className="p-2 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-brand-gold/20 outline-none"
                  />
                </div>
              ) : (
                <span className="text-sm text-gray-400 italic">Closed / Not Available</span>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}